
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 23"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M15.93 9V0h-12v9h3v2.62L12.17 9h3.76z"}}),_c('path',{attrs:{"fill":"#fff","d":"M6.76 2.22h6.34v4.39H6.76z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M8 21a4 4 0 00-1.62-3.2 3 3 0 10-4.76 0A4 4 0 000 21v2h8zM18.38 17.8a3 3 0 10-4.76 0A4 4 0 0012 21v2h8v-2a4 4 0 00-1.62-3.2z"}})])])])
          )
        }
      }
    